export const TABLE_PAGE_SIZE_OPTIONS = [
  10,
  20,
  50,
  100,
  150,
  200,
  300,
  500,
  1000,
] as const;

export const MAX_TABLE_PAGE_SIZE = 1000;
export const DEFAULT_TABLE_PAGE_SIZE = 10;

/** @deprecated Legacy "All" sentinel — use {@link MAX_TABLE_PAGE_SIZE} instead. */
export const ALL_RECORDS_PAGE_SIZE = 2_000_000_000;

const LEGACY_ALL_PAGE_SIZE_THRESHOLD = 10_000;

/** Maps legacy "All" page sizes and invalid values to the highest selectable size. */
export function normalizeTablePageSize(pageSize: number | undefined): number {
  if (pageSize == null || !Number.isFinite(pageSize) || pageSize <= 0) {
    return DEFAULT_TABLE_PAGE_SIZE;
  }
  if (
    pageSize >= LEGACY_ALL_PAGE_SIZE_THRESHOLD ||
    pageSize === ALL_RECORDS_PAGE_SIZE
  ) {
    return MAX_TABLE_PAGE_SIZE;
  }
  return pageSize;
}
